export { default } from '@embroider/util/services/ensure-registered';
